import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, MagentoProductAttributeList } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'common/productAttributeList',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<MagentoProductAttributeList>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchProductAttributeList (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().catalog.fetchProductAttributeList()
      const { data } = response.data || {}
      const { getProductAttributeList } = data || {}
      if (getProductAttributeList) {
        dispatch(success(getProductAttributeList))
      } else {
        dispatch(failure())
      }
      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
